"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Job = exports.JobStatus = void 0;
var create_archive_specification_1 = require("./create-archive-specification");
var extract_archive_specification_1 = require("./extract-archive-specification");
var extract_poster_specification_1 = require("./extract-poster-specification");
var extract_storyboard_specification_1 = require("./extract-storyboard-specification");
var file_import_specification_1 = require("./file-import-specification");
var packaging_specification_1 = require("./packaging-specification");
var source_1 = require("./source");
var transcode_specification_1 = require("./transcode-specification");
var JobStatus;
(function (JobStatus) {
    JobStatus["PENDING"] = "pending";
    JobStatus["WORKING"] = "working";
    JobStatus["SUCCESS"] = "success";
    JobStatus["ERROR"] = "error";
})(JobStatus = exports.JobStatus || (exports.JobStatus = {}));
var specifications = {
    'urn:job:archive.extract': extract_archive_specification_1.ExtractArchiveSpecification,
    'urn:job:archive.create': create_archive_specification_1.CreateArchiveSpecification,
    'urn:job:av.transcode': transcode_specification_1.TranscodeSpecification,
    'urn:job:av.poster': extract_poster_specification_1.ExtractPosterSpecification,
    'urn:job:av.storyboard': extract_storyboard_specification_1.ExtractStoryboardSpecification,
    'urn:job:import.file': file_import_specification_1.FileImportSpecification,
    'urn:job:av.package': packaging_specification_1.PackagingSpecification,
};
var Job = /** @class */ (function () {
    function Job(data) {
        this.issuer = null;
        this.status = JobStatus.PENDING;
        this.groupId = null;
        this.dateCreated = null;
        this.dateUpdated = null;
        this.sources = [];
        this.id = data.id;
        this.type = data.type;
        this.issuer = data.issuer;
        if (data.status) {
            this.status = data.status;
        }
        this.groupId = data.groupId;
        this.result = data.result;
        if (typeof data.sources !== 'undefined') {
            this.sources = data.sources.map(function (source) {
                return new source_1.Source(source);
            });
        }
        var Specification = specifications[this.type];
        this.specification = new Specification(data.specification);
        this.dateCreated = data.dateCreated;
        this.dateUpdated = data.dateUpdated;
    }
    /**
     * If job is pending or working
     * @returns {boolean}
     */
    Job.prototype.isWaiting = function () {
        return (this.status === JobStatus.PENDING || this.status === JobStatus.WORKING);
    };
    /**
     * If job has successfully finished
     * @returns {boolean}
     */
    Job.prototype.isSuccess = function () {
        return this.status === JobStatus.SUCCESS;
    };
    /**
     * If job failed
     * @returns {boolean}
     */
    Job.prototype.isError = function () {
        return this.status === JobStatus.ERROR;
    };
    return Job;
}());
exports.Job = Job;
//# sourceMappingURL=job.js.map